export default "__VITE_PUBLIC_ASSET__4d183533__"